export const CREDENTIALS_ROUTES = {
    LIST: '/credentials'
};

export const COLLECTOR_CREDENTIALS_TAB_INDEX = 0;
export const TARGET_CREDENTIALS_TAB_INDEX = 1;
export const ADVERITY_AUTHORIZATIONS_TAB_INDEX = 2;
